import axios from "axios";
import { FeaturesDto } from "healthex-common/features.dtos";
import { authenticatedApiConfig } from "./BaseApiService";
import { plainToInstance } from "class-transformer";
export class FeatureService {
    constructor(authenticationProvider, environment) {
        this.authenticationProvider = authenticationProvider;
        this.environment = environment;
    }
    async getFeaturesForOrganization(organizationId) {
        var _a;
        const response = await axios.get(`${this.environment.API_BASE_URL}/organizations/${organizationId}/features`, authenticatedApiConfig(this.authenticationProvider));
        const featuresDto = response.data ? plainToInstance(FeaturesDto, response.data) : null;
        return (_a = featuresDto === null || featuresDto === void 0 ? void 0 : featuresDto.features) !== null && _a !== void 0 ? _a : [];
    }
}
